<section class="hero is-primary is-fullheight-with-navbar">
  <div class="hero-body">
    <div class="content-wrapper has-text-centered">
      <div class="columns is-vcentered">
        <div class="column">
          <h1 class="title is-1 has-text-weight-bold">
            Launch Your Personal Brand in 48 Hours with AI-Powered Kits
          </h1>
          <p class="subtitle is-4 mt-3">
            A done-for-you AI-powered Brand Kit for coaches, creators &
            consultants — available with global delivery in 48 hours.
          </p>
          <div class="buttons is-centered mt-5">
            <button
              class="button is-light is-medium"
              (click)="showBookingForm()"
            >
              <strong>Get Your Brand Kit</strong>
            </button>
            <a
              href="https://admitted-cook-fe2.notion.site/Personal-Brand-Kit-Sample-Delivery-by-Geekeno-29889ddf315c80509e33f19197ac8f3c"
              target="_blank"
              class="button is-white is-outlined is-medium"
              >See a Sample</a
            >
          </div>
        </div>
        <div class="column">
          <figure class="image is-4by3 mt-6 illustration">
            <img
              src="/assets/products/brand-kit/personal-brand.svg"
              alt="AI Personal Brand Illustration"
            />
          </figure>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section">
  <div class="content-wrapper">
    <div class="columns is-vcentered">
      <div class="column has-text-centered">
        <img
          class="illustration"
          src="/assets/products/brand-kit/creative-process.svg"
          alt="Creative process illustration"
        />
      </div>
      <div class="column">
        <h2 class="title is-3">
          You know you need a personal brand — but where do you even start?
        </h2>
        <p class="subtitle is-5">
          Most creators and coaches waste weeks figuring out logos, tone, and
          what to post. Geekeno's AI-powered Personal Brand Kit does it all for
          you in 48 hours — so you can focus on growing your audience, not
          designing your brand.
        </p>
      </div>
    </div>
  </div>
</section>

<section class="section has-background-light">
  <div class="content-wrapper">
    <h2 class="title is-3 has-text-centered">
      What You'll Get — Delivered in 48 Hours
    </h2>
    <div class="columns is-multiline mt-5">
      <div class="column is-half">
        <div class="media">
          <div class="media-left">
            <span class="icon has-text-primary"
              ><i class="fa-solid fa-palette fa-2x"></i
            ></span>
          </div>
          <div class="media-content">
            <p class="title is-5">Custom AI Logo & Brand Palette</p>
            <p>Unique, modern visuals tailored to your vibe.</p>
          </div>
        </div>
      </div>
      <div class="column is-half">
        <div class="media">
          <div class="media-left">
            <span class="icon has-text-primary"
              ><i class="fa-solid fa-pen-nib fa-2x"></i
            ></span>
          </div>
          <div class="media-content">
            <p class="title is-5">Professional Bio & Tagline</p>
            <p>Written for LinkedIn, Instagram, and your website.</p>
          </div>
        </div>
      </div>
      <div class="column is-half">
        <div class="media">
          <div class="media-left">
            <span class="icon has-text-primary"
              ><i class="fa-solid fa-calendar-days fa-2x"></i
            ></span>
          </div>
          <div class="media-content">
            <p class="title is-5">15-Post Content Calendar</p>
            <p>Hooks, captions, and CTAs ready to post.</p>
          </div>
        </div>
      </div>
      <div class="column is-half">
        <div class="media">
          <div class="media-left">
            <span class="icon has-text-primary"
              ><i class="fa-solid fa-images fa-2x"></i
            ></span>
          </div>
          <div class="media-content">
            <p class="title is-5">5 Editable Canva Posts</p>
            <p>Carousels and quote cards in your brand style.</p>
          </div>
        </div>
      </div>
      <div class="column is-half">
        <div class="media">
          <div class="media-left">
            <span class="icon has-text-primary"
              ><i class="fa-solid fa-folder-open fa-2x"></i
            ></span>
          </div>
          <div class="media-content">
            <p class="title is-5">All Files in One Drive Folder</p>
            <p>Simple, organized, and ready to use instantly.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="pricing" class="section">
  <div class="content-wrapper has-text-centered">
    <h2 class="title is-3">
      The 48-Hour Launch Kit —
      <span class="has-text-primary">{{
        brandKitPrice() | currency: pricingCurrency() : "symbol" : "1.0-0"
      }}</span>
    </h2>
    <p class="subtitle is-5 mb-5">
      We only take 3 clients per week to keep turnaround fast & quality high.
    </p>
    <div class="price-box mx-auto" style="max-width: 600px">
      <p class="is-size-4 mb-4">
        <strong>Get your brand built in 2 days — guaranteed.</strong>
      </p>
      <button
        class="button is-primary is-medium is-fullwidth mb-3"
        (click)="showBookingForm()"
      >
        <strong>Book Your Slot</strong>
      </button>
      <a
        href="https://admitted-cook-fe2.notion.site/Personal-Brand-Kit-Sample-Delivery-by-Geekeno-29889ddf315c80509e33f19197ac8f3c"
        target="_blank"
        class="button is-light is-fullwidth"
        >View a Sample Kit</a
      >
    </div>
  </div>
</section>

<section class="section has-background-light">
  <div class="content-wrapper">
    <h2 class="title is-3 has-text-centered">
      Trusted by Early-Stage Creators & Coaches
    </h2>
    <div class="columns is-centered mt-5">
      <div class="column is-half">
        <article class="message is-success">
          <div class="message-body">
            &ldquo;Geekeno nailed my brand identity in two days — from the logo
            to the content plan. Absolute time-saver!&rdquo;
            <br /><strong>— Pilot Client, Business Coach</strong>
          </div>
        </article>
      </div>
      <div class="column is-half">
        <article class="message is-link">
          <div class="message-body">
            &ldquo;Fast, smart, and creative. The AI-powered approach gave me
            clarity I&rsquo;d been missing for months.&rdquo;
            <br /><strong>— Creator Consultant</strong>
          </div>
        </article>
      </div>
    </div>
    @if (brandKitDiscount()) {
      <p class="has-text-centered mt-5">
        We're onboarding early adopters — first few clients get
        <strong
          >{{
            brandKitDiscount()
              | currency: pricingCurrency() : "symbol" : "1.0-0"
          }}
          off</strong
        >
        in exchange for feedback.
      </p>
    }
  </div>
</section>

<section class="section">
  <div class="content-wrapper has-text-centered">
    <h2 class="title is-2">Your Brand, Done-for-You in 48 Hours</h2>
    <p class="subtitle is-5 mb-5">
      Let's turn your expertise into a brand that stands out — fast, clean, and
      future-ready.
    </p>
    <button class="button is-primary is-large" (click)="showBookingForm()">
      <strong>Get Started Now</strong>
    </button>
  </div>
</section>

<div class="modal" [class.is-active]="shouldShowBookingForm()">
  <div class="modal-background"></div>
  <div class="modal-card booking-form">
    <header class="modal-card-head">
      <h2 class="modal-card-title">Book Your Personal Brand Launch Kit</h2>
      <button
        class="delete is-large"
        aria-label="close"
        (click)="hideBookingForm()"
      ></button>
    </header>
    <form
      id="bookingForm"
      (submit)="createOrder()"
      [formGroup]="form"
      class="modal-card-body"
    >
      <div class="form-group">
        <div class="form-control-wrapper">
          <label class="label"
            >Full Name
            <input
              type="text"
              placeholder="John Doe"
              formControlName="full_name"
              required
              autocomplete="given-name"
            />
          </label>

          @if (
            form.controls.full_name.invalid && form.controls.full_name.touched
          ) {
            <div class="error-message">Full name is required.</div>
          }
        </div>
      </div>
      <div class="form-group">
        <div class="form-control-wrapper">
          <label class="label"
            >Email Address
            <div class="help">
              We use this to share access to the Brand Kit and send emails about
              the payment confirmation.
            </div>
            <input
              type="email"
              placeholder="you@example.com"
              formControlName="email"
              required
              autocomplete="email"
            />
          </label>

          @if (form.controls.email.invalid && form.controls.email.touched) {
            @if (form.controls.email.hasError("required")) {
              <div class="error-message">Email is required.</div>
            } @else {
              <div class="error-message">
                Please enter a valid email address.
              </div>
            }
          }
        </div>
      </div>
      <div class="form-group">
        <div class="form-control-wrapper">
          <label class="label"
            >Mobile Number
            <div class="help">
              We <i>may</i> use this to contact you on WhatsApp with questions
              about your brand.
            </div>
            <input
              type="tel"
              placeholder="+1 234 456789"
              formControlName="phone"
              required
              autocomplete="tel"
            />
          </label>

          @if (form.controls.phone.invalid && form.controls.phone.touched) {
            @if (form.controls.phone.hasError("required")) {
              <div class="error-message">Mobile number is required.</div>
            } @else {
              <div class="error-message">
                Please enter a valid mobile number, including country code.
              </div>
            }
          }
        </div>
      </div>
      <div class="form-group">
        <div class="form-control-wrapper">
          <label class="label"
            >Tell us briefly about your brand or goal
            <textarea
              class="textarea"
              formControlName="goal"
              placeholder="What do you want to achieve with your brand?"
              required
            ></textarea>
          </label>

          @if (form.controls.goal.invalid && form.controls.goal.touched) {
            <div class="error-message">Your brand brief is required.</div>
          }
        </div>
      </div>
      <div class="label">
        Existing Social Links (optional)
        <div class="help">
          Helps us understand your brand's current look and feel.
        </div>
      </div>
      <div class="form-group">
        <div class="form-control-wrapper">
          <label class="label"
            >LinkedIn
            <input
              class="input"
              type="text"
              formControlName="linkedin"
              placeholder="https://linkedin.com/yourhandle"
            />
          </label>
        </div>
        <div class="form-control-wrapper">
          <label class="label"
            >Instagram
            <input
              class="input"
              type="text"
              id="instagram"
              formControlName="instagram"
              placeholder="https://instagram.com/yourhandle"
            />
          </label>
        </div>
        <div class="form-control-wrapper">
          <label class="label"
            >Facebook
            <input
              class="input"
              type="text"
              formControlName="facebook"
              placeholder="https://facebook.com/yourhandle"
            />
          </label>
        </div>
      </div>
    </form>
    <footer class="modal-card-foot is-flex-direction-column">
      @if (shouldShowBookingError()) {
        <p class="help has-text-danger">
          Something went wrong. Please try again.
        </p>
      }
      <button
        type="submit"
        class="button is-primary is-medium is-fullwidth"
        form="bookingForm"
      >
        Book Now for
        @if (brandKitDiscount()) {
          &nbsp;
          <del>{{
            brandKitPrice() | currency: pricingCurrency() : "symbol" : "1.0-0"
          }}</del
          >&nbsp;
        }
        {{
          brandKitDiscountedPrice()
            | currency: pricingCurrency() : "symbol" : "1.0-0"
        }}
      </button>
      @if (brandKitDiscount()) {
        <p class="help">
          Early adopters get
          <strong
            >{{
              brandKitDiscount()
                | currency: pricingCurrency() : "symbol" : "1.0-0"
            }}
            off</strong
          >
          in exchange for feedback.
        </p>
      }
    </footer>
  </div>
</div>

<div class="modal" [class.is-active]="shouldShowPaymentError()">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head has-background-danger-light">
      <h2 class="modal-card-title has-text-danger-dark">Payment Cancelled</h2>
    </header>
    <section class="modal-card-body">
      <p class="has-text-grey-dark mb-4">
        The payment for your Brand Kit was cancelled. The work will not be
        started until you make a new payment. You can either retry the payment
        now or resubmit your details at a later time.
      </p>
    </section>
    <footer class="modal-card-foot">
      <div class="buttons is-centered is-flex-grow-1">
        <button class="button is-primary" (click)="attemptPayment()">
          <span class="icon"><fa-icon [icon]="icons.redo" /></span>
          <span>Retry Payment</span>
        </button>
        <button class="button is-danger" (click)="hidePaymentError()">
          <span class="icon"><fa-icon [icon]="icons.cancel" /></span>
          <span>Cancel Order</span>
        </button>
      </div>
    </footer>
  </div>
</div>

<div class="modal" [class.is-active]="shouldShowPaymentSuccess()">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head has-background-success-light">
      <h2 class="modal-card-title has-text-success-dark">
        <fa-icon [icon]="icons.success" />&nbsp; Payment Successful
      </h2>
      <button
        class="delete"
        aria-label="close"
        (click)="hidePaymentSuccess()"
      ></button>
    </header>

    <section class="modal-card-body has-text-centered">
      <figure class="image is-128x128 is-inline-block mb-4">
        <img
          src="/assets/products/brand-kit/order-confirmed.svg"
          alt="Order Confirmed"
        />
      </figure>
      <h2 class="title is-4">We've got your order!</h2>
      <p class="subtitle is-6 mt-2 mb-4">
        Thank you for choosing Geekeno's <strong>Brand Kit</strong> service. Our
        creative team will get started right away and contact you within the
        next <strong>24 hours</strong> to confirm your preferences and timeline.
      </p>

      <div class="buttons is-centered mt-5">
        <a class="button is-primary" href="/">
          <fa-icon [icon]="icons.home" />&nbsp; Back to Home
        </a>
        <a
          class="button is-light"
          href="https://wa.me/919823994536"
          target="_blank"
        >
          <fa-icon [icon]="icons.whatsapp" />&nbsp; Contact Support
        </a>
      </div>
    </section>
  </div>
</div>
